import React from 'react';
import Button from 'common/components/elements/buttons/primary';
import PropTypes from 'prop-types';
import './style.scss';
import DateFormatter from 'common/utils/DateFormatter';
import cx from 'classnames';
import CountState from 'admin/views/media-modules/count-state';
import { property } from 'lodash';
import Intercom from 'common/utils/Intercom';
import { ARTICLE_ID_ON_LIVESTREAM } from 'common/utils/intercom-articles';
import { moreInfoProps } from 'common/utils/utils';

const HeaderButtons = ({
   isMobile,
   goTo,
   date,
   hasAccess,
   isOnline,
   countesState,
   screenWidth,
   isReorderMode,
   setReorderMode,
   onClickPreview,
}) => {

   const upcomingButton = (
      <div
         className={ cx({
            'inline-block h-11 upcoming-button': true,
         }) }
      >
         <Button
            text={ `${ date ? `Scheduled livestream: ${ DateFormatter.getDateByTimzeonFormat(date) }` : 'Schedule an upcoming livestream' } ` }
            padding='none'
            iconPosition='left'
            borderRadius='large'
            backgroundColor={ `${ date ? 'panel border border-divider hover:bg-hover' : 'panel' }` }
            textColor='major'
            textSize='base'
            fontIconColor='secondary'
            textPosition='left'
            alignment='between'
            twoIcon={ isMobile }
            iconName={ 'clock' }
            secondIconName={ isMobile ? 'arrow-right' : null }
            onClick={ _ => {
               goTo('schedule')
            }
            }
            disabled={ !hasAccess || isReorderMode }
            classNames={ `h-full px-5 isMobile &&  py-2.5 ${ !hasAccess ? 'opacity-50 cursor-default' : '' } whitespace-nowrap ` }
            textMarginX='0'
            textClassName={ `${ isReorderMode ? '!text-disabled' : '' } pl-2` }
            iconClassName={ `${ isReorderMode ? '!text-disabled' : '' }` }
         />
      </div>
   )
   const dateIsValid = DateFormatter.checkIsValid(date);
   return (
      <>
         {
            isMobile && dateIsValid && (
               upcomingButton
            )
         }
         <div
            className={ cx({
               'flex justify-between items-center px-6 max-[1024px]:px-4 pt-8 max-[1024px]:pt-6 max-[779px]:flex-col flex-row max-[779px]:items-start gap-2': true,
               'mb-8': !isMobile,
               'mb-4': isMobile,
               'flex-col-reverse !items-start gap-2 ': !isMobile && dateIsValid && screenWidth < 1200,
            }) }
         >
            <div
               className={ cx({
                  'flex gap-2 max-[779px]:flex-col flex-wrap flex-1': true,
               }) }
            >
               <div
                  className={ cx({
                     'inline-block h-11 create-buttons': true,
                  }) }
               >
                  <Button
                     primaryColor
                     text={ (dateIsValid || isOnline) ? 'Go to studio' : 'Create livestream' }
                     padding='none'
                     iconName='online-stream'
                     iconPosition='left'
                     borderRadius='large'
                     onClick={ _ => {
                        let pageName = 'create';
                        if(isOnline){
                           pageName = 'studio'
                        }
                        goTo(pageName)
                     } }
                     disabled={ !hasAccess || isReorderMode }
                     classNames={ `h-full px-5 py-2.5 ${ !hasAccess ? 'cursor-default' : '' } whitespace-nowrap !w-[fit-content]` }
                     textMarginX='0'
                     textClassName='pl-2'
                     fontWeight='medium'
                     textSize='base'
                     fontIconSize='extraLarge'
                  />
               </div>
               {
                  !isMobile && dateIsValid && (
                     upcomingButton
                  )
               }
               <Button
                  text={ isReorderMode ? 'Done' : 'Reorder' }
                  onClick={ setReorderMode }
                  iconName={ isReorderMode ? '' : 'drag' }
                  iconPosition='left'
                  borderRadius='large'
                  backgroundColor={ isReorderMode ? '' : 'major-dark' }
                  textColor='major'
                  fontIconColor='secondary'
                  textSize='base'
                  classNames={ cx({
                     'px-5 py-[10px] flex flex-row gap-2 border border-divider h-11 !w-[fit-content] whitespace-nowrap ': true,
                     'hover:!bg-hover intercom-reorder-content': !isReorderMode,
                  }) }
                  // iconClassName={ `${ isReorderMode ? '!rotate-90' : '' }` }
                  textMarginX='0'
                  primaryColor={ isReorderMode }
               />
               {
                  isReorderMode &&
                  <Button
                     text='Preview on my site'
                     onClick={ onClickPreview }
                     iconName='go-to'
                     fontIconSize='extraLarge'
                     iconPosition='left'
                     borderRadius='large'
                     backgroundColor='major-dark'
                     textColor='major'
                     fontIconColor='secondary'
                     textSize='base'
                     classNames='px-5 py-[10px] flex flex-row gap-2 border border-divider h-11 !max-w-[fit-content] hover:!bg-hover whitespace-nowrap'
                     textMarginX='0'
                  />
               }
               {
                  countesState && (
                     <CountState
                        state={ countesState }
                        type={ isReorderMode ? `published stream${ countesState?.total > 1 ? 's' : '' } can be reordered` : 'stream' }
                        className='whitespace-nowrap !justify-start mt-auto max-[779px]:mt-2 pl-4'
                        hideTooltip={ isReorderMode }
                     />
                  )
               }
            </div>
            <div className='inline-block h-9 more-info max-[779px]:order-first'>
               <Button
                  primaryColor
                  text='More info on livestream'
                  padding='none'
                  iconName='attention-outline'
                  iconPosition='left'
                  classNames='h-full whitespace-nowrap'
                  borderRadius='large'
                  backgroundColor='transparent'
                  textSize='small'
                  fontIconSize='base'
                  { ...moreInfoProps() }
                  onClick={ () => Intercom.showArticle(ARTICLE_ID_ON_LIVESTREAM) }
               />
            </div>
         </div>
      </>
   );
};

HeaderButtons.propTypes = {
   isMobile: PropTypes.bool,
   goTo: PropTypes.func,
   date: PropTypes.string,
   hasAccess: PropTypes.bool,
   isOnline: PropTypes.bool,
   countesState: PropTypes.object,
   screenWidth: PropTypes.number,
   isReorderMode: PropTypes.bool,
   setReorderMode: PropTypes.func,
   onClickPreview: property.func,
};

export default React.memo(HeaderButtons);
